import { ClientTableV2 } from '@components/TableV2/ClientTableV2';
import { useLazyLoadTab } from '@hooks/useLazyLoadTab/useLazyLoadTab';
import { TabEventKeys, TableNames } from '@utils/constants';
import { useGetContractPaymentScheduleHistoryQuery } from './queries/useContractPaymentScheduleHistoryQuery';
import { useGetContractPaymentScheduleHistoryV2Columns } from './useGetContractPaymentScheduleHistoryV2Columns';

interface IContractPaymentScheduleHistoryTableV2 {
  uuid: string;
}

export const ContractPaymentScheduleHistoryTableV2 = ({
  uuid,
}: IContractPaymentScheduleHistoryTableV2) => {
  const columns = useGetContractPaymentScheduleHistoryV2Columns();

  const { hasTabBeenClicked } = useLazyLoadTab({
    eventKey: TabEventKeys.CONTRACT_PAYMENT_SCHEDULE_HISTORY_V2,
  });
  const {
    isScheduleHistoryLoading,
    scheduleHistoryData,
    scheduleHistoryError,
  } = useGetContractPaymentScheduleHistoryQuery({
    uuid,
    enabled: !!uuid && hasTabBeenClicked,
  });

  const tableData = scheduleHistoryData?.rows ?? [];

  return (
    <ClientTableV2
      columns={columns}
      data={tableData}
      error={scheduleHistoryError}
      isInTab={true}
      isLoading={isScheduleHistoryLoading}
      name={TableNames.PAYMENT_SCHEDULE_HISTORY_V2}
      wrapTableInCard={false}
    />
  );
};
